export interface PartnerWallet {
  walletName: string;
  colorPalette: string;
  companyLogUrl: string;
  webUrl: string;
  chevronBtnColor: string;
}

export const partnerWallet: PartnerWallet[] = [
  {
    walletName: 'Lobstr',
    colorPalette: '#1B8DA0',
    companyLogUrl: 'assets/images/wallets/lobstr.svg',
    webUrl: 'https://lobstr.co/home/',
    chevronBtnColor: '#FFFFFF',
  },
  {
    walletName: 'Whitebit',
    colorPalette: '#08080c',
    companyLogUrl: 'assets/images/wallets/whitebit.svg',
    webUrl: 'https://whitebit.com/',
    chevronBtnColor: '#FFFFFF',
  },
];
